import httpClient from "httpClient"

export const post = params => { 
    
    const pathname = '/paciente'

    const body = {
        ...params,
        cpfPaciente: params.cpfPaciente.replace(/[^0-9]/g,'')
    }
    
    return httpClient.post(pathname, body)
    
}

export const byCPF = params => { 
    
    const pathname = '/paciente/cpf'

    const body = {
        ...params,
        cpfPaciente: params.cpfPaciente.replace(/[^0-9]/g,'')
    }
    
    return httpClient.post(pathname, body)
    
}

const paciente = {
    post,
    byCPF, 
}

export default paciente

